module.exports = __webpack_public_path__ + "files/7350876ed9eaf44d9555c8d5674d2790.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-600italic.svg
 ** module id = 954
 ** module chunks = 0
 **/